import { z } from "zod";

/** What the share server answers when it can't do what was asked, like a 404 or a 413. */
export const Problem = z.object({
    error: z.string(),
});

export type Problem = z.infer<typeof Problem>;

/** The answer to an upload that isn't newer than what the share server has (a 409): the version it has. */
export const VersionConflict = Problem.extend({
    version: z.int().positive(),
});

export type VersionConflict = z.infer<typeof VersionConflict>;
